import storage from '../../storage';
import { walletAddressAtom } from '../wallet';
import { createAsyncAtom } from '../../lib/state';

const userRefereeAtom = createAsyncAtom(async get => {
  try {
    const walletAddress = await get(walletAddressAtom);
    if (!walletAddress) {
      return null;
    }

    const referee = await storage.getUserReferee(walletAddress);
    if (!referee) {
      return null;
    }

    return referee;
  } catch (e) {
    console.error('userRefereeAtom - Failed to get user referee', e);
    return null;
  }
});
export default userRefereeAtom;
